import { styled } from '@mui/material/styles';
import { cssVarColors } from '../../Constants';
import { contentWidth, mobileThreshold } from '../../Constants/layoutValues';

export const ShenizCanvasingWrapper = styled('div')`
	min-height: 100vh;
	height: 100%;
	width: 100vw;
	background-color: ${cssVarColors.surface};
	color: #fff;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-top: 1rem;
`;

export const ContentWrapper = styled('div')`
	width: ${contentWidth};
	@media (max-width: ${mobileThreshold}px) {
		width: 100%;
	}
`;

export const QuestionWrapper = styled('div')`
	padding-top: 1rem;
	padding-bottom: 1rem;
	padding-left: 1rem;
	padding-right: 1rem;
	:nth-of-type(even) {
		background-color: #00000030;
	}
`;

export const Question = styled('div')`
	font-family: montserratSemiBold;
	padding-bottom: 0.5rem;
`;

export const AnswersWrapper = styled('div')`
	padding-left: 1rem;
`;

export const AnswerWrapper = styled('div')`
	padding-top: 0.5rem;
	padding-bottom: 0.5rem;
`;

export const HeadersWrapper = styled('div')`
	padding-bottom: 0.25rem;
`;

export const NameWrapper = styled('div')`
	font-family: montserratItalics;
`;

export const DateTimeWrapper = styled('div')``;

export const TeamWrapper = styled('div')``;

export const TitleWrapper = styled('div')``;

export const AnswerContentWrapper = styled('div')`
	padding-left: 0.5rem;
`;
